import CallToActionHeader from "components/CallToAction/CallToActionHeader";
import CallToFaqSection from "components/CallToAction/CallToFaqSection";
import HowItWorkCallToAction from "components/CallToAction/HowItWorkCallToAction";
import { RESERVATION_FAQ, RESERVATION_HOW_IT_WORKS } from "data/constants";
import AboutUsPage from "elements/Pages";
import AdvanceTabPage from "elements/advance-tab";
import { FC } from "react";
import { Helmet } from "react-helmet";
import { IoIosSend } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import presta from "../../images/commentcamarche/prestataires_evenementiels.png";
import "../../styles/css/next-styles.css";
import Banner from "./Banner";
import BenefitsSection from "./BenefitsSection";
export interface SectionHowItWorkProps {
  className?: string;
}

const HowItWorks: FC<SectionHowItWorkProps> = ({ className = "pt-6 pb-6" }) => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>
          Réservez un espace événementiel à l’heure | Trouvez un prestataire événementiel facilement – Comment ça
          marche ?{" "}
        </title>
        <meta
          name="description"
          content="Réserver à l’heure un espace événementiel pour votre événement. trouver un prestataire événementiels en toute simplicité."
        />
      </Helmet>

      <div className="dark:bg-neutral-800">
        {/* Light Mode Overlay */}
        <div className="relative dark:hidden" data-white-overlay="10">
          <Banner />
        </div>

        {/* Dark Mode Overlay */}
        <div className="relative hidden dark:block" data-black-overlay="1">
          <Banner />
        </div>

        <div>
          <AboutUsPage />
        </div>
        <div className="dark:bg-neutral-800">
          <AdvanceTabPage />
        </div>
        <div className="mt-16 ">
          <HowItWorkCallToAction
            title={RESERVATION_HOW_IT_WORKS.title}
            stepCircleColor="bg-eventToBeeYellow"
            steps={RESERVATION_HOW_IT_WORKS.steps}
            titleHighlight=""
            bg="bg-white"
          />
        </div>

        <BenefitsSection />

        <div className="py-8 bg-white md:py-12 lg:py-16 dark:bg-neutral-800">
          <div className="max-w-full px-4 mx-auto font-sans rounded-lg bg-eventToBee sm:max-w-2xl md:max-w-3xl lg:max-w-7xl">
            <div className="flex justify-center items-center min-h-[200px] sm:min-h-[250px]">
              <div className="grid items-center w-full max-w-md grid-cols-1 text-center sm:max-w-lg md:max-w-xl">
                <div>
                  <p className="p-4 text-lg font-medium text-white sm:p-6 sm:text-4xl">
                    Réservez votre espace maintenant
                  </p>
                </div>
                <div className="mb-4 sm:mb-6">
                  <Link to={"/espace-evenementiel"}>
                    <button className="flex items-center justify-center w-48 px-4 py-2 mx-auto space-x-1 text-sm font-medium text-blue-700 transition duration-200 bg-white rounded-full shadow-md hover:bg-blue-100 sm:w-80">
                      <IoIosSend className="w-10 h-10" />
                      <span>Découvrez nos lieux disponibles</span>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CallToActionHeader
          bg="bg-white"
          imageSrc={presta}
          buttonAction={() => navigate("/prestations")}
          buttonText="Trouver un prestataire"
          highlightText="prestataire"
          Htitle="h2"
          title="Trouver votre prestataire événementiel pour un événement réussi"
          description="Vous cherchez un prestataire événementiel à Paris pour organiser un événement mémorable ? Que ce soit pour un mariage, un séminaire d’entreprise, une soirée d’entreprise, un anniversaire ou un lancement de produit, trouvez facilement les meilleurs prestataires grâce à notre plateforme. Faites de votre événement un succès en accédant à une sélection variée de services professionnels et personnalisés qui répondent à tous types de projets événementiels : corporate, privé ou culturel."
        />

        <div className="">
          <CallToFaqSection toggleBgColor="bg-eventToBeeYellow" bg="bg-white" faqs={RESERVATION_FAQ} />
        </div>
      </div>
    </>
  );
};

export default HowItWorks;
